import { render, staticRenderFns } from "./fbAndIcbu.vue?vue&type=template&id=2e5d415c&scoped=true"
import script from "./fbAndIcbu.vue?vue&type=script&lang=js"
export * from "./fbAndIcbu.vue?vue&type=script&lang=js"
import style0 from "./fbAndIcbu.vue?vue&type=style&index=0&id=2e5d415c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d415c",
  null
  
)

export default component.exports